import React, { useState, useEffect, lazy, useMemo } from "react";
import Container from "react-bootstrap/Container";
// import LogoDark from "../img/headerLogo.jpg";
import LogoDark from "../img/headerLogo.svg";
import Toggle from "../img/toggle.svg";
// import LogoDark from "../img/headerImage.webp";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import Offcanvas from "react-bootstrap/Offcanvas";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { FaApple } from "react-icons/fa";
import { TiVendorAndroid } from "react-icons/ti";
import Drawer from "@mui/material/Drawer";
import { connect, useDispatch } from "react-redux";
import Loadable from "../../../router/loadable";
import CloseIcon from "@mui/icons-material/Close";
import { OrderFlow } from "../../../App";
import { jwtDecode } from "jwt-decode";
import { isMobile } from "react-device-detect";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Fade from "@mui/material/Fade";
import "./headerRes.scss";
import { VscAccount } from "react-icons/vsc";
import { FiBox } from "react-icons/fi";
import { IoMdBook } from "react-icons/io";
import { RiContactsBook2Line } from "react-icons/ri";
import { MdOutlineArrowBackIos } from "react-icons/md";
import { FaSearch } from "react-icons/fa";

import { HiShoppingBag } from "react-icons/hi2";
import { FaUserCircle } from "react-icons/fa";
import { FiUser } from "react-icons/fi";
import { IoIosHelpCircleOutline } from "react-icons/io";
import { MdAccountBalanceWallet } from "react-icons/md";
import { IoMdExit } from "react-icons/io";
import { HashLink } from "react-router-hash-link";
import {
  setLoggedIn,
  login,
  logout,
} from "../../../actions/login/authssoActions";
import { getFooter } from "../../../actions/home/footerAction";
import { getSocial } from "../../../actions/home/socialAction";
import { getMenuImage } from "../../../actions/home/menuImageAction";
import { getAboutUs } from "../../../actions/home/aboutAction";
import { getMealDeal } from "../../../actions/home/mealDealAction";
import { getHomepage } from "../../../actions/home/homepageActions";
import { getGallery } from "../../../actions/home/galleryAction";
import { getSignup } from "../../../actions/home/signupAction";
import { getFeedBack } from "../../../actions/home/feedBackAction";
import { getReview } from "../../../actions/home/reviewAction";
import { getMainTableBooking } from "../../../actions/home/mainTableBookingAction";
import { subcribePlanOrder } from "../../../actions/subscribe/subscribePlanAction";
import MyaccountMobile from "../../../pages/myaccount/Myaccount-mobile";
import { Box, Divider, Typography } from "@mui/material";

const SignIn = Loadable(lazy(() => import("../../../pages/sign-in/sign-in")));

const HeaderRes = ({ userData, login, logout, home }) => {
  const isLoggedIn =
    localStorage.getItem("isLoggedIn") == "true" ? true : false;

  const [anchorEl, setAnchorEl] = React.useState(null);
  const navigate = useNavigate();
  const open = Boolean(anchorEl);
  const handleClicks = (event) => {
    // setAnchorEl(event.currentTarget);
    navigate("/myaccount");
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const [getUrlLink, setUrlLink] = useState();
  const [getImageUrl, setImageUrl] = useState();
  const [getImageAlt, setImageAlt] = useState();
  const [showAboutUs, setShowAboutUs] = useState(true);
  const [showMealDealMenu, setShowMealDealMenu] = useState(true);
  const [showGallery, setShowGallery] = useState(true);
  const [showBookTable, setShowBookTable] = useState(true);
  const [btnTextUrl, setBtnTextUrl] = useState({
    contactText: "Contact Us",
    orderText: "Order Now",
    subscribeText: "Subscription",
    franchisText: "",
    cartText: "Cart",
    contactUrl: "",
    orderUrl: "",
    subscribeUrl: "",
    franchisUrl: "",
    cartUrl: "",
  });
  const [showbtn, setShowBtn] = useState({
    SubscriptionStatus: "",
    cartButtonStatus: "",
    ContactUsStatus: "",
    OrderNowStatus: "",
  });
  const [isApp, setIsApp] = useState(false);

  useEffect(() => {
    const storedValue = localStorage.getItem("isApp");
    setIsApp(storedValue === "true");
  }, []);

  const [AccountOpen, setAccountOpen] = useState(false);

  const toggleDrawer = (prop) => {
    setAccountOpen(prop);
  };

  const [showReview, setShowReview] = useState(true);
  const location = useLocation();
  const [showOffcanvas, setShowOffcanvas] = useState(false);
  const reduxDispatch = useDispatch();
  const [config, setConfig] = useState(window?.appConfig ?? null);
  const apiResponse = localStorage.getItem("apiRes");
  const showOrderNowButton = !location.pathname.endsWith("/menu");
  const [showMobileCart, setShowMobileCart] = useState(false);
  const cartClientPath = localStorage.getItem("cartClientPath");
  const clientAppLogo = localStorage.getItem("clientAppLogo")
    ? localStorage.getItem("clientAppLogo")
    : "";
  const { pathname } = useLocation();
  const [mobileTopText, setMobileTopText] = useState(null);
  const [isTableQr, setTableQr] = useState(null);
  const {
    setLoginPopupShow,
    getOrderMode,
    getCollectionTab,
    getDeliveryTab,
    setCollectionTab,
    setDeliveryTab,
    setOrderTime,
    setOrderMode,
    // setOneTabShow,
    moveToCheck,
    setMoveToCheck,
    setLogo,
    setHeaderButtonResponse,
    topHeaderStatus,
    restaurant,
    setMenuFilterShow,
  } = OrderFlow();
  const [isSccroll, setIsSccroll] = useState(false);
  const [width, setWidth] = useState(window.innerWidth);

  const breakpoint = 767;
  useEffect(() => {
    const handleResizeWindow = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResizeWindow);
    return () => {
      window.removeEventListener("resize", handleResizeWindow);
    };
  }, []);

  const GoBackFunction = () => {
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      const prevCartMenu = localStorage.getItem("cartClientPath");
      navigate(`/${prevCartMenu}/menu`);
    }
  };

  useEffect(() => {
    if (
      userData &&
      userData?.status &&
      userData?.customerId &&
      (userData?.login_type == 1 || userData?.login_type == 2)
    ) {
      reduxDispatch(setLoggedIn());
      // setOneTabShow(false);
    }
  }, [reduxDispatch, userData]);

  const handleLogout = () => {
    const discountJSON = localStorage.getItem("discount");
    const discount = discountJSON ? JSON.parse(discountJSON) : "";
    localStorage.clear("SubcripeCoupon");
    reduxDispatch(subcribePlanOrder());
    localStorage.clear("subscribePlan");
    if (discount?.source == "SubscriptionCoupon") {
      localStorage.clear("discount");
    }
    logout();
    if (location.pathname.includes("/checkout")) {
      navigate(-1);
    } else if (!location.pathname.includes("/menu")) {
      navigate("/");
    }
  };

  const handleScroll = () => {
    try {
      let number =
        window?.pageXOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        3;

      if (number >= 5) {
        if (window.innerWidth < 5) {
          setIsSccroll(false);
        } else {
          setIsSccroll(true);
        }
      } else {
        setIsSccroll(false);
      }
    } catch (error) {}
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const tableId = params.get("tableName");
    if (tableId) {
      setTableQr(tableId);
    } else {
      setTableQr(null);
    }

    if (location.pathname.endsWith("/checkout")) {
      setMobileTopText("Checkout");
      setShowMobileCart(false);
    } else if (location.pathname.endsWith("/myaccount")) {
      setMobileTopText("My acconut");
      setShowMobileCart(true);
    } else if (location.pathname.endsWith("/yourorder")) {
      setMobileTopText("Your Order");
    } else if (location.pathname.endsWith("/addressbook")) {
      setMobileTopText("My address");
    } else if (location.pathname.endsWith("/tablebooking")) {
      setMobileTopText("Booking");
    } else if (location.pathname.endsWith("/savedcards")) {
      setMobileTopText("Saved Card");
    } else if (location.pathname.endsWith("/feedbackmyaccount")) {
      setMobileTopText("Feedback");
    } else if (location.pathname.endsWith("/help")) {
      setMobileTopText("Help");
    } else if (location.pathname.endsWith("/orderdetail")) {
      setMobileTopText("Order detail");
    } else if (location.pathname.endsWith("/addcard")) {
      setMobileTopText("Add card");
    } else if (location.pathname.endsWith("/myorder")) {
      setMobileTopText("Order History");
    } else if (location.pathname.endsWith("/")) {
      setShowMobileCart(true);
    } else if (location.pathname.endsWith("/orderstatus")) {
      setMobileTopText("Order Status");
    } else if (location.pathname.endsWith("/list")) {
      setMobileTopText("Restaurants");
    } else if (location.pathname.endsWith("/partner")) {
      setMobileTopText("Become a partner");
    } else {
      setMobileTopText(restaurant?.restaurantName);
      setShowMobileCart(false);
    }
  }, [location, restaurant]);

  const handleClick = (url, event) => {
    event.preventDefault();
    if (url.startsWith("http://") || url.startsWith("https://")) {
      window.location.href = url;
    } else {
      navigate(url);
    }
  };

  useEffect(() => {
    const handler = () => setConfig(window?.appConfig);
    window.addEventListener("appConfigUpdated", handler);
    return () => window.removeEventListener("appConfigUpdated", handler);
  }, []);

  useEffect(() => {
    const extractParameters = () => {
      const queryParams = new URLSearchParams(window.location.search);
      const googleLoginParam = queryParams.get("google_login");
      const facebookLoginParam = queryParams.get("facebook_login");
      const appleLoginParam = queryParams.get("apple_login");

      if (googleLoginParam === "1") {
        queryParams.delete("google_login");
        const remainingParams = {};
        queryParams.forEach((value, key) => {
          remainingParams[key] = value;
        });
        localStorage.setItem("google_login", JSON.stringify(remainingParams));
        const googleDetailsString = localStorage.getItem("google_login");
        const googleDetails = JSON.parse(googleDetailsString);
        const postData = {
          verfication_code: googleDetails.id,
          email: googleDetails.email,
          login_type: 1,
          first_name: googleDetails.given_name,
          last_name: googleDetails.family_name,
        };
        console.log(postData);
        login(JSON.stringify(postData));
        const path = localStorage.getItem("clientPath");
        if (moveToCheck && location.pathname.includes("/menu")) {
          setMoveToCheck(false);
          localStorage.setItem("moveToCheck", false);
          navigate(`/${path}/checkout`);
        } else {
          if (location.pathname.includes("/app")) {
            // navigate('/');
            window.location.href = "/";
          } else {
            navigate(window.location.pathname);
          }
        }

        // window.history.replaceState({}, document.title, newUrl);
      } else if (facebookLoginParam === "1") {
        queryParams.delete("facebook_login");
        const remainingParams = {};
        queryParams.forEach((value, key) => {
          remainingParams[key] = value;
        });
        localStorage.setItem("facebook_login", JSON.stringify(remainingParams));

        const facebookDetailsString = localStorage.getItem("facebook_login");
        const facebookDetails = JSON.parse(facebookDetailsString);
        const postData = {
          verfication_code: facebookDetails["facebook_data[FBID]"] || "",
          email: facebookDetails["facebook_data[EMAIL]"] || "",
          login_type: 2,
          first_name: facebookDetails["facebook_data[F_NAME]"] || "",
          last_name: facebookDetails["facebook_data[L_NAME]"] || "",
        };
        login(JSON.stringify(postData));
        const path = localStorage.getItem("clientPath");
        if (moveToCheck && location.pathname.includes("/menu")) {
          setMoveToCheck(false);
          localStorage.setItem("moveToCheck", false);
          navigate(`/${path}/checkout`);
        } else {
          if (location.pathname.includes("/app")) {
            // navigate('/');
            window.location.href = "/";
          } else {
            navigate(window.location.pathname);
          }
        }
      } else if (appleLoginParam === "1") {
        queryParams.delete("apple_login");
        const remainingParams = {};
        queryParams.forEach((value, key) => {
          remainingParams[key] = value;
        });
        localStorage.setItem("apple_login", JSON.stringify(remainingParams));
        const appleDetailsString = localStorage.getItem("apple_login");
        const googleDetails = JSON.parse(appleDetailsString);
        console.log(googleDetails);

        const decodedToken = jwtDecode(googleDetails.code);
        console.log(decodedToken);
        const email = decodedToken.email;
        const firstName = "";
        const lastName = "";
        const postData = {
          verfication_code: decodedToken.c_hash,
          login_type: 4,
          email: email,
          first_name: firstName,
          last_name: lastName,
        };

        login(JSON.stringify(postData));
        const path = localStorage.getItem("clientPath");
        if (moveToCheck && location.pathname.includes("/menu")) {
          setMoveToCheck(false);
          localStorage.setItem("moveToCheck", false);
          navigate(`/${path}/checkout`);
        } else {
          if (location.pathname.includes("/app")) {
            // navigate('/');
            window.location.href = "/";
          } else {
            navigate(window.location.pathname);
          }
        }
      } else {
        localStorage.setItem("google_login", "");
        localStorage.setItem("facebook_login", "");
        localStorage.setItem("apple_login", "");
      }
    };

    extractParameters();
  }, []);

  useEffect(() => {
    let root = document.documentElement;
    const data = config ?? window?.appConfig;

    if (data) {
      setUrlLink(data?.data?.header?.orderNowLink);
      setImageUrl(data?.data?.header?.logoImage);
      setImageAlt(data?.data?.header?.businessName);
      setLogo(data?.data?.header?.b2cLogo);
      const pageConfig = data?.data?.pageConfig;
      setShowMealDealMenu(pageConfig?.mealDeal !== 0);
      setShowAboutUs(pageConfig?.aboutUs !== 0);
      setShowGallery(pageConfig?.gallery !== 0);
      setShowBookTable(pageConfig?.bookTable !== 0);
      localStorage.setItem("booking_status", pageConfig?.bookTable);
      setShowReview(pageConfig?.review !== 0);
      setHeaderButtonResponse(data?.data?.header?.button);
      const buttonTextConfig = data?.data?.header?.buttonText;
      const navCartBtn = buttonTextConfig?.cartButton
        ? buttonTextConfig?.cartButton
        : "Cart";
      const navContactBtn = buttonTextConfig?.contactUsButton || "Contact Us";
      const franchiseBtn =
        buttonTextConfig?.franchiseButton || "BECOME FRANCHISE";
      const navorderNowBtn = buttonTextConfig?.orderNowButton || "Order Now";
      const navsubscriptionBtn =
        buttonTextConfig?.subscriptionButton || "SUBCRIPTION";
      //button url
      const path = localStorage.getItem("path");
      const buttonURLConfig = data?.data?.header?.buttonLink;
      const navCartURL = buttonURLConfig?.cartButton
        ? buttonURLConfig.cartButton
        : path + "/menu";
      const navContactURL = buttonURLConfig?.contactUsButton || "/#contact-nav";
      const navFranchiseURL =
        buttonURLConfig?.franchiseButton || "/become-franchise";
      const navorderNowURL = buttonURLConfig?.orderNowButton || path + "/menu";
      const navsubscriptionURL = buttonURLConfig?.subscriptionButton || "";

      setBtnTextUrl({
        contactText: navContactBtn,
        franchisText: franchiseBtn,
        orderText: navorderNowBtn,
        subscribeText: navsubscriptionBtn,
        cartText: navCartBtn,
        contactUrl: navContactURL,
        orderUrl: navorderNowURL,
        cartUrl: navCartURL,
        franchisUrl: navFranchiseURL,
        subscribeUrl: navsubscriptionURL,
      });

      const headerButtonResponse = data?.data?.header?.button;
      const OrderNowStatus =
        headerButtonResponse?.orderNowButtonStatus === 1 &&
        !location.pathname.endsWith("/checkout") &&
        !location.pathname.endsWith("/menu");
      const cartButtonStatus = headerButtonResponse?.cartButtonStatus === 1;
      const ContactUsStatus =
        showOrderNowButton && headerButtonResponse?.contactUsButtonStatus === 1;
      //   const booknowLink = `/${localStorage.getItem("path")}/tablebook`;
      const SubscriptionStatus =
        headerButtonResponse?.subscriptionButtonStatus === 1;

      setShowBtn({
        cartButtonStatus: cartButtonStatus,
        OrderNowStatus: OrderNowStatus,
        ContactUsStatus: ContactUsStatus,
        SubscriptionStatus: SubscriptionStatus,
      });

      localStorage.setItem("configLogo", data?.data?.header?.b2cLogo);
    }

    if (data?.data?.theme) {
      const { background, color } = data?.data?.theme;
      root.style.setProperty("--theme-background", background);
      root.style.setProperty("--theme-color", color);
      if (color === "#ffffff") {
        root.style.setProperty("--theme-color-only", background);
      } else {
        root.style.setProperty("--theme-color-only", color);
      }
    }
    if (data?.data?.header?.navbar) {
      const { foregroundColor, backgroundColor } = data?.data?.header?.navbar;
      console.log(foregroundColor, backgroundColor, "3333");

      root.style.setProperty("--theme-navbar-background", backgroundColor);
      root.style.setProperty("--theme-navbar-color", foregroundColor);
    }
    if (data?.data?.header?.buttonCss) {
      const backgroundColor =
        data?.data?.header?.buttonCss?.orderNowButtonBackgroundColor;
      const foregroundColor =
        data?.data?.header?.buttonCss?.orderNowButtonForegroundColor;
      root.style.setProperty("--theme-nav-btn-background", backgroundColor);
      root.style.setProperty("--theme-nav-btn-color", foregroundColor);
    }
    if (data?.data?.header?.font) {
      const font_family_name = data?.data?.header?.font?.font_family_name;
      document.documentElement.style.setProperty(
        "--theme-font-family",
        font_family_name
      );
    }
  }, [
    config,
    location.pathname,
    setHeaderButtonResponse,
    setLogo,
    showOrderNowButton,
  ]);

  useEffect(() => {
    setShowOffcanvas(false);
    setAccountOpen(false);
  }, [location.pathname]);

  const menus = [
    {
      menu: btnTextUrl.orderText ?? "Order Now",
      url: btnTextUrl.orderUrl,
      icon: <FiBox size={25} />,
      redir: (event) => handleClick(btnTextUrl.orderUrl, event),
      show: false,
      // show: showbtn.OrderNowStatus,
    },
    {
      menu: "Book Now",
      url: `/${localStorage.getItem("path")}/tablebook`,
      as: HashLink,
      icon: <IoMdBook size={25} />,
      show: false,
      // show:
      //   showBookTable &&
      //   apiResponse !== "2" &&
      //   !location.pathname.endsWith("/menu") &&
      //   !location.pathname.endsWith("/tablebook") &&
      //   !location.pathname.endsWith("/checkout"),
    },
    {
      menu: btnTextUrl.contactText ?? "Contact Us",
      url: btnTextUrl.contactUrl ?? "/",
      as: HashLink,
      icon: <RiContactsBook2Line size={25} />,
      show: false,
      // showbtn.ContactUsStatus &&
      // !location.pathname.endsWith("/menu") &&
      // !location.pathname.endsWith("/checkout"),
    },
    {
      menu: "Meal Deal",
      url: "/#meal-deal-page",
      as: HashLink,
      show:
        false &&
        !location.pathname.endsWith("/menu") &&
        !location.pathname.endsWith("/checkout"),
    },
    {
      menu: "Gallery",
      url: "/#gallery-nav",
      as: HashLink,
      show:
        false &&
        !location.pathname.endsWith("/menu") &&
        !location.pathname.endsWith("/checkout"),
    },
    {
      menu: btnTextUrl.cartText,
      cartvalue: localStorage.getItem("cartQty"),
      url: btnTextUrl.cartUrl,
      icon: <HiShoppingBag className="d-md-none" size={20} />,
      iconcount: (
        <span className="itemCount">
          {" "}
          &#8226; {localStorage.getItem("cartQty")}
        </span>
      ),
      class: "cartBtn",
      // redir: (event) => {
      //   const prevCartMenu = localStorage.getItem("cartClientPath");
      //    navigate(`/${prevCartMenu}/menu`);
      // },
      redir: (event) =>
        localStorage.getItem("cartQty") > 0
          ? handleClick(`/${cartClientPath}/menu`, event)
          : null,
      show:
        localStorage.getItem("cartQty") > 0 &&
        showbtn.cartButtonStatus &&
        !location.pathname.endsWith("/menu") &&
        !location.pathname.endsWith("/checkout"),
      // showbtn.cartButtonStatus
      //   ? true
      //   : false,
    },
    {
      menu: "Help",
      url: "/help",
      icon: <IoIosHelpCircleOutline size={25} />,
      as: HashLink,
      show: false,
      class: apiResponse === "2" ? "dy-header-btn" : "nav-link-1",
    },
  ];

  const scrollWithOffset = (el) => {
    const yCoordinate = el.getBoundingClientRect().top + window.pageYOffset;
    const yOffset = -50;
    window.scrollTo({ top: yCoordinate + yOffset, behavior: "smooth" });
  };

  return (
    <>
      <Navbar
        key={"md"}
        expand={"md"}
        // sticky="top"
        id="mobileAppheader"
        className={
          pathname == "/app" && !isLoggedIn
            ? "d-none"
            : "bg-white bg-body-tertiary sticky-top1 "
        }
      >
        <Container className="">
          {isMobile &&
          pathname != "/" &&
          pathname != "/app" &&
          !pathname.endsWith("/menu") &&
          !pathname.endsWith("/list") ? (
            <div className="back-ic">
              <button onClick={GoBackFunction}>
                <MdOutlineArrowBackIos style={{ color: "#fff" }} />
              </button>
              {mobileTopText != null ? (
                <h3 className="bac-name">{mobileTopText}</h3>
              ) : topHeaderStatus ? (
                <div
                  className="d-flex justify-content-between w-100 container"
                  onClick={() => setMenuFilterShow(true)}
                >
                  <h3
                    className="bac-name one_line"
                    onClick={() => setMenuFilterShow(true)}
                    style={{ width: "200px" }}
                  >
                    {restaurant?.restaurantName}
                  </h3>
                </div>
              ) : isTableQr ? (
                <>
                  <div className="bac-name-container1">
                    <h3 className="table-name-order1">
                      {isTableQr.length > 17
                        ? isTableQr.slice(0, 17) + "..."
                        : isTableQr}
                    </h3>
                  </div>
                </>
              ) : (
                <h3 style={{ width: "200px" }} className="bac-name one_line">
                  {restaurant?.restaurantName}
                </h3>
              )}
            </div>
          ) : (
            <div className="d-flex align-items-center  gap-3">
              <img
                role="button"
                onClick={() => toggleDrawer(true)}
                src={Toggle}
                className="d-md-block d-none"
                width={30}
                height={30}
                alt=""
              />
              <div className="logo_d">
                <Nav.Link as={Link} to={"/"} eventKey={0}>
                  <img src={LogoDark} alt={getImageAlt} />
                </Nav.Link>
              </div>
            </div>
          )}

          {/* <div className="logo_d">
            <Nav.Link as={Link} to={"/"} eventKey={0}>
              <img src={LogoDark} alt={getImageAlt} />
            </Nav.Link>
          </div> */}

          {isSccroll && location.pathname.endsWith("/menu") && isMobile ? (
            <FaSearch
              size={20}
              className="me-2"
              onClick={() => setMenuFilterShow(true)}
            />
          ) : (
            <div>
              {apiResponse &&
                apiResponse !== "2" &&
                localStorage.getItem("cartQty") > 0 &&
                showMobileCart && (
                  <div
                    className="cartmobiles d-inline-block d-lg-none me-3"
                    onClick={() => {
                      const prevCartMenu =
                        localStorage.getItem("cartClientPath");
                      navigate(`/${prevCartMenu}/menu`);
                    }}
                  >
                    <HiShoppingBag
                      className="d-md-none"
                      size={width < 767 ? 30 : 20}
                    />
                    {localStorage.getItem("cartQty") > 0 && (
                      <span className="itemCount">
                        {localStorage.getItem("cartQty")}
                      </span>
                    )}
                  </div>
                )}
              {/* <Navbar.Toggle
                onClick={() => toggleDrawer(true)}
                // onClick={() => setShowOffcanvas(true)}
                aria-controls={`topheaderNavbar-expand-md`}
              /> */}
              <img
                role="button"
                onClick={() => toggleDrawer(true)}
                src={Toggle}
                className="d-md-none"
                width={30}
                height={30}
                alt=""
              />
            </div>
          )}

          <Navbar.Offcanvas
            id={`topheaderNavbar-expand-md`}
            aria-labelledby={`TopHeaderNavbarLabel-expand-md`}
            placement="start"
            show={showOffcanvas}
            onHide={() => setShowOffcanvas(false)}
            className={
              localStorage.getItem("isApp") == "true"
                ? "shadow top-navc"
                : "top-navc"
            }
          >
            <Offcanvas.Header
              className={
                localStorage.getItem("isApp") == "true" ? "app-side " : ""
              }
              // closeButton
            >
              <Offcanvas.Title id={`TopHeaderNavbarLabel-expand-md`}>
                <div className="logo_d">
                  <Nav.Link as={Link} to={"/"} eventKey={0}>
                    <img
                      src={LogoDark}
                      // src={clientAppLogo ? clientAppLogo : getImageUrl}
                      alt={getImageAlt}
                    />
                  </Nav.Link>
                </div>
              </Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body className="p-0">
              <Nav className="justify-content-end flex-grow-1 pe-sm-3">
                {menus.map(
                  (menu, index) =>
                    menu.show !== false && (
                      <div className="mob-side">
                        <Nav.Link
                          as={menu.as}
                          key={index}
                          eventKey={6 + index}
                          to={menu.url}
                          id={`menuridect${index}`}
                          onClick={menu.redir}
                          smooth
                          className={
                            menu?.class
                              ? menu?.class
                              : apiResponse === "2"
                              ? "dy-header-btn"
                              : "nav-link-1"
                          }
                          scroll={(el) => scrollWithOffset(el)}
                          style={menu.style}
                          data-Fus="fus-test-BookOrdermap"
                        >
                          <div>
                            <span className="me-2 d-sm-none">{menu.icon}</span>
                            {menu.menu}{" "}
                            {menu.cartvalue ? `- ${menu.cartvalue}` : ""}
                          </div>
                        </Nav.Link>
                      </div>
                    )
                )}

                <Nav.Link
                  smooth
                  // onClick={handleClicks}
                  onClick={() => navigate("/partner")}
                  className="d-none d-md-block"
                  data-Fus="fus-test-CardOrderdata"
                >
                  <div className="d-flex align-items-center w-100 justify-content-center">
                    {/* <FiUser className="me-2 mt-0" /> */}
                    Become a partner
                  </div>
                </Nav.Link>

                {isLoggedIn ? (
                  <>
                    <div className="d-md-none">
                      <div
                        role="button"
                        onClick={() => {
                          document.getElementById("myAccountred")?.click();
                        }}
                        className="mob-side"
                      >
                        <Nav.Link
                          as={Link}
                          to={"/myaccount"}
                          eventKey="5"
                          smooth
                          id="myAccountred"
                          scroll={(el) => scrollWithOffset(el)}
                          data-Fus="fus-test-CardOrderdata"
                        >
                          <div>
                            <span className="me-2">
                              <FiUser size={25} />
                            </span>
                            My Account
                          </div>
                        </Nav.Link>
                      </div>
                      <div
                        onClick={() => {
                          document
                            .getElementById(
                              "myaccountWalletRedmyaccountWalletRed"
                            )
                            ?.click();
                        }}
                        className="mob-side "
                      >
                        <Nav.Link
                          as={Link}
                          to="/savedcards"
                          eventKey="6"
                          id="myaccountWalletRed"
                          smooth
                          scroll={(el) => scrollWithOffset(el)}
                          data-Fus="fus-test-CardOrderdata"
                        >
                          <div>
                            <span className="me-2">
                              <MdAccountBalanceWallet size={25} />
                            </span>
                            Saved Card
                          </div>
                        </Nav.Link>
                      </div>
                      <div
                        role="button"
                        onClick={handleLogout}
                        className="mob-side"
                      >
                        <Nav.Link
                          smooth
                          as={Link}
                          to={!location.pathname.includes("/menu") ? "/" : "#"}
                          scroll={(el) => scrollWithOffset(el)}
                          data-Fus="fus-test-CardOrderdata"
                        >
                          <div>
                            <span className="me-2">
                              <IoMdExit size={25} />
                            </span>
                            Logout
                          </div>
                        </Nav.Link>
                      </div>
                    </div>
                    <div className="drop_m">
                      <Nav.Link
                        smooth
                        // onClick={handleClicks}
                        onClick={() => toggleDrawer(true)}
                        className="d-none d-md-block"
                        data-Fus="fus-test-CardOrderdata"
                      >
                        <div className="d-flex align-items-center w-100 justify-content-center">
                          <FiUser className="me-2 mt-0" />
                          My Account
                          {/* <div className="text-capitalize">
                            Hi {userData?.fname}
                          </div> */}
                          {/* <KeyboardArrowDownIcon /> */}
                        </div>
                      </Nav.Link>
                      <Menu
                        id="fade-menu"
                        slotProps={{
                          list: {
                            "aria-labelledby": "fade-button",
                          },
                        }}
                        slots={{ transition: Fade }}
                        anchorEl={anchorEl}
                        open={open}
                        className="d-none d-md-block"
                        onClose={handleClose}
                      >
                        <MenuItem
                          onClick={() => {
                            // eslint-disable-next-line no-unused-expressions
                            handleClose(), navigate("/myaccount");
                          }}
                        >
                          <FaUserCircle className="me-2" /> My Account
                        </MenuItem>
                        <MenuItem
                          onClick={() => {
                            // eslint-disable-next-line no-unused-expressions
                            handleClose(), navigate("/myaccount/savedcards");
                          }}
                        >
                          <MdAccountBalanceWallet className="me-2" /> Saved
                          Cards
                        </MenuItem>
                        <MenuItem onClick={handleLogout}>
                          <IoMdExit className="me-2" /> Logout
                        </MenuItem>
                      </Menu>
                    </div>
                  </>
                ) : (
                  <>
                    {
                      // pathname.endsWith("/menu") ||
                      // pathname.endsWith("/tablebook") ?
                      <div className="d-flex align-items-center sign-wi">
                        <SignIn isLoggedIn={isLoggedIn} />
                      </div>
                      // : null
                    }
                    {/* {showbtn.SubscriptionStatus && (
                      <Subscription btnText={btnTextUrl.subscribeText} />
                    )} */}
                  </>
                )}
              </Nav>
            </Offcanvas.Body>
          </Navbar.Offcanvas>
        </Container>
      </Navbar>
      <Drawer
        open={AccountOpen}
        anchor="left"
        onClose={() => toggleDrawer(false)}
        sx={
          width < breakpoint
            ? {
                "& .MuiDrawer-paper": {
                  width: "100vw",
                  height: "100vh",
                  paddingTop: isApp ? "60px" : "",
                  boxSizing: "border-box",
                },
                zIndex: 9999,
              }
            : {
                zIndex: 9999,
              }
        }
      >
        <Box
          display="flex"
          flexDirection="column"
          // justifyContent="space-between"
          height="100%"
          sx={
            width > breakpoint
              ? {
                  maxWidth: "370px",
                }
              : null
          }
          width="100%"
          p={0}
          className="mb-sm-0 mb-5 pb-sm-0 pb-5"
        >
          <Box className="text-center">
            <div className="gap-3 mob-logoS d-flex align-items-center justify-content-between">
              <div className="logo_d">
                <Nav.Link as={Link} to={"/"} eventKey={0}>
                  <img
                    // style={{ width: "162px", height: "56px" }}
                    src={LogoDark}
                    alt={getImageAlt}
                  />
                </Nav.Link>
              </div>
              <CloseIcon
                sx={{ cursor: "pointer" }}
                className="me-2 mt-1"
                onClick={() => toggleDrawer(false)}
              />
            </div>
            <Divider sx={{ mb: 0, borderColor: "#000" }} />
          </Box>
          {/* <Box px={2} > */}
          {isLoggedIn ? (
            <MyaccountMobile handleSideMenu={() => toggleDrawer(false)} />
          ) : (
            <div className="d-flex mb-3 h-100 flex-column justify-content-between">
              <div className="px-3 mt-3">
                <button
                  onClick={() => {
                    document.getElementById("handleLoginpopup")?.click();
                    toggleDrawer(false);
                  }}
                  className="btn btn-dark vbtn w-100 mb-3"
                  style={{ minWidth: "300px", padding: "12px" }}
                >
                  Login
                </button>

                <button
                  onClick={() => {
                    toggleDrawer(false);
                    navigate("/partner");
                  }}
                  className="btn fw-semibold vbtn w-100"
                  style={{
                    minWidth: "300px",
                    padding: "12px",
                    backgroundColor: "#F4F4F4",
                  }}
                >
                  Become a partner
                </button>
              </div>
              {localStorage.getItem("isApp") != true ? (
                <div className="px-3">
                  <div className="d-flex gap-3 align-items-center mb-4">
                    <img src="/logo.png" width={80} height={80} alt="" />
                    <h5 className="mb-0 text-wrap ">
                      There's more to love in <br /> the app.
                    </h5>
                  </div>

                  <div className="d-flex align-items-center gap-2">
                    <button
                      onClick={() => {
                        toggleDrawer(false);
                        window.open(
                          "https://apps.apple.com/us/app/fusion-kitchen/id1485360740",
                          "_blank"
                        );
                      }}
                      className="btn fw-semibold d-flex justify-content-center alin-items-center vbtn w-100"
                      style={{
                        borderRadius: "26px",
                        padding: "12px",
                        backgroundColor: "#F4F4F4",
                      }}
                    >
                      <FaApple size={25} className="me-2" />
                      <span>Iphone</span>
                    </button>

                    <button
                      onClick={() => {
                        toggleDrawer(false);
                        // navigate("/partner");
                        window.open(
                          "https://play.google.com/store/apps/details?id=com.fusionkitchen&hl=en",
                          "_blank"
                        );
                      }}
                      className="btn fw-semibold d-flex justify-content-center align-items-center vbtn w-100"
                      style={{
                        borderRadius: "26px",
                        padding: "12px",
                        backgroundColor: "#F4F4F4",
                      }}
                    >
                      <TiVendorAndroid size={25} className="me-2" />
                      <span>Android</span>
                    </button>
                  </div>
                </div>
              ) : (
                ""
              )}
            </div>
          )}
          {/* </Box> */}
        </Box>
      </Drawer>
    </>
  );
};

const mapStateToProps = (state) => ({
  // response: state.footer.response,
  isLoggedIn: state.userdata.isLoggedIn,
  userData: state.userdata.userData,
  postCode: state.postCode,
  // social: state.social.response,
  // menuImage: state.menuImage.response,
  home: state.homepage.response,
});

const mapDispatchToProps = {
  getHomepage,
  getFooter,
  getSocial,
  getMenuImage,
  getMealDeal,
  getAboutUs,
  getGallery,
  getSignup,
  getReview,
  getFeedBack,
  logout,
  login,
  setLoggedIn,
  getMainTableBooking,
};

export default connect(mapStateToProps, mapDispatchToProps)(HeaderRes);
